import queryString from "query-string";

import { func_validation, isStringNotEmpty } from "./func_validation";



export const func_url = {
    
    getPathNameFromURL,
    getUrlParametersFromURL,
    getQueryStringFromURL,
	getQueryStringValueFromURL,
    
	historyReplaceToURL,
	historyPushToURL,
	historyPushToSelf,
    directToURL,
    
    softRefreshPage,

    saveAndOpenInNewTab,
    
    combineQueryString,
    combineUrlAndQueryString,
    setFormatQueryString,
    combineUrlWithCombinedQueryStrings,
	
	checkIsIOS,

	checkIsMobile,
	checkIsInMobileSubdomain,

	scrollWindowToTop,

};

export function getParamListObj(location) {
    let search = location?.search;
    if (isStringNotEmpty(search)) {
        search = search.substring(1); // REmove the ? symbol
        let list = search.split("&");
        
        let obj = {};
        list.map((item) => {
            // seperate the name and value
            let array = item.split("=");
            let name = array[0];
            let value = array[1];
            obj[name] = value;
        });

        return obj;
    }
    return {};
}

function getPathNameFromURL(props) {
    const { location } = props;
    if (func_validation.isNotNullUndefined(location) && 
        func_validation.isNotNullUndefined(location.pathname)) {
        return location.pathname;
    }
    return undefined;
}

function getUrlParametersFromURL(props, paramName) {
    const { match } = props;

    // Get Order Unit ID
    if (func_validation.isNotNullUndefined(paramName) && 
        func_validation.isNotNullUndefined(match) && 
        func_validation.isNotNullUndefined(match.params) && 
        func_validation.isNotNullUndefined(match.params[paramName])) {
        return match.params[paramName];
    }

    return undefined;
}

function getQueryStringFromURL(props) {
    const { location } = props;
    if (func_validation.isNotNullUndefined(location) && 
        func_validation.isNotNullUndefined(location.search)) {
        // NOTE: queryString.parse does not add _proto_ 
        // (e.g. object.hasOwnProperty would not work)
        return queryString.parse(location.search);
    }
    return {};
}

function getQueryStringValueFromURL(props, propName, defaultVal) {
	return func_validation.getObjectPropertyValue(getQueryStringFromURL(props), propName, defaultVal);
}

function historyReplaceToURL(props, url) {
	const { history } = props;
	if (func_validation.isNotNullUndefined(history) && 
		func_validation.isStringTrimNotEmpty(url)) {
		history.replace(url);
	}
}

function historyPushToURL(props, url, opts) {
    const { history } = props;
    if (func_validation.isNotNullUndefined(history) && 
        func_validation.isStringTrimNotEmpty(url)) {
		
		if (func_validation.isObjectNotEmpty(opts)) {
			history.push(url, opts);
		} else history.push(url);
    }
}

function historyPushToSelf(props, url) {
	let url_formatted = (func_validation.isStringTrimNotEmpty(url))?url:"";
	
	let queryStringObj = getQueryStringFromURL(props);
	let queryStringArray = [];

	if (func_validation.isObjectNotEmpty(queryStringObj)) {
		Object.keys(queryStringObj).map((queryString)=>{

			queryStringArray.push(
				setFormatQueryString(queryString, queryStringObj[queryString])
			);
			
		});
	}
	
	if (func_validation.isStringTrimNotEmpty(url_formatted)) {
		historyPushToURL(
			props, 
			combineUrlAndQueryString(url_formatted, queryStringArray)
		);
	}
}

function directToURL(locationHref) {
    window.location.href = locationHref;
}

function softRefreshPage(history) {
    history.push("/");
    history.goBack();
}

function saveAndOpenInNewTab(storageList, url) {
    if (func_validation.isStringTrimNotEmpty(url) &&
        func_validation.isArrayNotEmpty(storageList)) {

        // Save to local storage
        let storage = window.localStorage;
        storageList.map((storageItem, idx) => {
            let name = func_validation.getObjectPropertyValue(storageItem, "name");
            let value = func_validation.getObjectPropertyValue(storageItem, "value");
            storage.setItem(name, value);
        });

        // Open new tab
        window.open(url, "_blank");
    }
}

function combineQueryString(queryStringArray) {
    if (func_validation.isArrayNotEmpty(queryStringArray)) {
        return queryStringArray.reduce((acc, cur)=>{ return acc+"&"+cur; });
    }
    return "";
}

function combineUrlAndQueryString(baseUrl, queryStringArray) {
    if (!func_validation.isStringTrimNotEmpty(baseUrl)) return "";
    if (func_validation.isArrayNotEmpty(queryStringArray)) {
        return baseUrl + combineQueryString(queryStringArray);
    }
    return baseUrl;
}

function setFormatQueryString(property, value, isJSON) {
    let value_toString = value + "";
    if (func_validation.isStringTrimNotEmpty(property) && 
        func_validation.isStringTrimNotEmpty(value_toString)) {
        if (func_validation.isBooleanTrueNotNullUndefined(isJSON)) {
            return property+"="+(encodeURIComponent( JSON.stringify(value_toString) ));
        }
        return property+"="+(encodeURIComponent(value_toString));
    }
    return undefined;
}

function combineUrlWithCombinedQueryStrings(url, paramObj, defaultObj) {
    if (!func_validation.isStringTrimNotEmpty(url)) return "";

    let paramArray = [];
    for (let key in paramObj) {
        let defaultValue = func_validation.getObjectPropertyValue(defaultObj, key, "");
        let paramSet = paramObj[key] ? paramObj[key] : defaultValue;

        if (func_validation.isObject(paramSet)) {
            let queryString_formatted = setFormatQueryString(key, paramSet, true);
            paramArray.push(queryString_formatted);
        }
        else {
            let paramSet_formatted = encodeURIComponent(paramSet);

            if (!func_validation.isStringTrimNotEmpty(paramSet_formatted))
                paramArray.push(key + "=");
            else paramArray.push(setFormatQueryString(key, paramSet_formatted));
        }
    }
    
    return combineUrlAndQueryString(url + "?", func_validation.filterNegatedElementFromArray(paramArray));
}

function checkIsIOS() {
	return navigator.userAgent.match(/ipad|ipod|iphone/i);
}

function checkIsMobile() {
	let isMobile = false;
	
	// device detection
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
		|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0,4))) { 
		isMobile = true;
	}

	return isMobile;
}

function checkIsInMobileSubdomain(hostOverwrite) {
	let urlDomain = hostOverwrite || window.location.host;
	let urlDomainArray = urlDomain.split(".");
	
	let startNode = 0;
	if (urlDomainArray[0] == "www") startNode = 1;
	
	let isMobileSubDomain = false;
	try {
		isMobileSubDomain = (urlDomainArray[startNode] == "m");
	} catch (e) { isMobileSubDomain = false; }

	return isMobileSubDomain;
}

function scrollWindowToTop() {
	window.scrollTo(0, 0);
}


